import { privateClient } from "@/api/privateClient";
import { SUPER_ADMIN_ENDPOINTS } from "../../../endpoint";
import type { TestimonialsSection, TestimonialItem } from "../types";

export const getTestimonials = async (): Promise<TestimonialsSection> => {
  const { data } = await privateClient.get(SUPER_ADMIN_ENDPOINTS.CMS.TESTIMONIALS.GET);
  return data.section;
};

export const updateTestimonialsSection = async (
  payload: Pick<TestimonialsSection, "badgeText" | "headingLine1" | "headingLine2" | "subtitle">
): Promise<TestimonialsSection> => {
  const { data } = await privateClient.put(SUPER_ADMIN_ENDPOINTS.CMS.TESTIMONIALS.UPDATE, payload);
  return data.section ?? data;
};

export const addTestimonial = async (payload: Omit<TestimonialItem, "id">): Promise<TestimonialItem> => {
  const { data } = await privateClient.post(SUPER_ADMIN_ENDPOINTS.CMS.TESTIMONIALS.ADD, payload);
  return data.testimonial ?? data;
};

export const updateTestimonial = async (id: number, payload: Omit<TestimonialItem, "id">): Promise<TestimonialItem> => {
  const { data } = await privateClient.put(SUPER_ADMIN_ENDPOINTS.CMS.TESTIMONIALS.UPDATE_ITEM(id), payload);
  return data.testimonial ?? data;
};

export const removeTestimonial = async (id: number): Promise<number> => {
  await privateClient.delete(SUPER_ADMIN_ENDPOINTS.CMS.TESTIMONIALS.REMOVE_ITEM(id));
  return id;
};

export const uploadTestimonialLogo = async (file: File): Promise<{ logoUrl: string }> => {
  const formData = new FormData();
  formData.append("logo", file);
  const { data } = await privateClient.post("/uploads/logo", formData);
  return data;
};